import { routes } from '../../src/router';
const state = {
  routers: routes,
  activeKey: "",
  audUuid : null,
  tableSelectArr: [],
  permissionbtn: [],
  Myrouters: [],
  DateYear:{},
  BtnPermissionData:[],
  //不同用户登录进来标签展示的集合列表
  TabsPermissionData: [],
  //不同用户登录进来展示的标签名称
  TabsPermissionName: {},

  //判断是菜单还是页签点击进入
  isMenuState:'menu',


  keepLiveTags: [
    {
      fullPath: "/HomeWorks",
      path: "/HomeWorks",
      title: "工作台"
    }
  ],
  modalVisible: false,
  formConfig: [],
  tableData: [],
  loading: false,
  tableSelected: [],
  token: "",
  name: "",
  mymenudata: [],
  columns: [],
  Color: '#FFFFFF',
  supernormalRouters:{
  code: "auditorExamptionConfirm",
  component: "auditorExamptionConfirm",
  code2: "normal",
  id: "8000",
  name: "免试认定数据报送",
  Icon: {
  components: "svg-data",
    theme: "outline",
    size: 20,
    fill: ["rgba(255, 255, 255, 0.65)"],
    strokeWidth: 3
},
  order: 0,
  parentId: null,
  title: "免试认定数据报送",
  path: "/auditorExamptionConfirm",
  child: [
  {
    code: "/auditorExamptionConfirm/filingsManage",
    component: "auditorExamptionConfirm/filingsManage",
    code2: "filings",
    id: "80001",
    name: "备案管理",
    order: 0,
    parentId: "8000",
    parentMenu: "normal",
    title: "备案管理",
    path: "/auditorExamptionConfirm/filingsManage",
    child: [
      {
        code: "/auditorExamptionConfirm/filingsManage/normaleProvinceLeader",
        component: "auditorExamptionConfirm/filingsManage/normaleProvinceLeader",
        code2: "normaleProvinceLeader",
        id: "800012",
        name: "改革工作组备案",
        order: 0,
        parentId: "80001",
        parentMenu: "filingsManage",
        title: "改革工作组备案",
        url: "/auditorExamptionConfirm/filingsManage/normaleProvinceLeader"
      },
      {
        code: "/auditorExamptionConfirm/filingsManage/schoolnormaleUniversity",
        component: "auditorExamptionConfirm/filingsManage/schoolnormaleUniversity",
        code2: "schoolnormaleUniversity",
        id: "80007",
        name: "80007",
        order: 0,
        parentId: "8000",
        parentMenu: "normal",
        title: "查看学校备案信息",
        url: "/auditorExamptionConfirm/filingsManage/schoolnormaleUniversity"
      },
      {
        code: "/auditorExamptionConfirm/filingsManage/normaleUniversity",
        component: "auditorExamptionConfirm/filingsManage/normaleUniversity",
        code2: "normaleUniversity",
        id: "800011",
        name: "免试认定高校备案",
        order: 0,
        parentId: "80001",
        parentMenu: "filingsManage",
        title: "免试认定高校备案",
        url: "/auditorExamptionConfirm/filingsManage/normaleUniversity"
      },
      {
        code: "/auditorExamptionConfirm/filingsManage/normalEduAbilityAssess",
        component: "auditorExamptionConfirm/filingsManage/normalEduAbilityAssess",
        code2: "normalEduAbilityAssess",
        id: "800013",
        name: "教育教学能力考核办法备案",
        order: 0,
        parentId: "80001",
        parentMenu: "filingsManage",
        title: "教育教学能力考核办法备案",
        url: "/auditorExamptionConfirm/filingsManage/normalEduAbilityAssess"
      },

      {
        code: "/auditorExamptionConfirm/filingsManage/normaleUniversityRoster",
        component: "auditorExamptionConfirm/filingsManage/normaleUniversityRoster",
        code2: "normaleUniversityRoster",
        id: "800014",
        name: "免试高校及专业名单管理",
        order: 0,
        parentId: "80001",
        parentMenu: "filingsManage",
        title: "免试高校及专业名单管理",
        url: "/auditorExamptionConfirm/filingsManage/normaleUniversityRoster"
      },
    ]
  },
  {
    code: "/auditorExamptionConfirm/reviewTime",
    component: "auditorExamptionConfirm/reviewTime",
    code2: "reviewTime",
    id: "80002",
    name: "数据报送及审核时间管理",
    order: 0,
    parentId: "8000",
    parentMenu: "normal",
    title: "数据报送及审核时间管理",
    path: "/auditorExamptionConfirm/reviewTime",
    child: [
      {
        code: "/auditorExamptionConfirm/reviewTime/NormalBatch",
        component: "auditorExamptionConfirm/reviewTime/NormalBatch",
        code2: "NormalBatch",
        id: "800098",
        name: "NormalBatch",
        order: 0,
        parentId: "80002",
        parentMenu: "reviewTime",
        title: "报送批次设置",
        url: "/auditorExamptionConfirm/filingsManage/NormalBatch"
      },
      {
        code: "/auditorExamptionConfirm/reviewTime/normalUploadTimeSet",
        component: "auditorExamptionConfirm/reviewTime/normalUploadTimeSet",
        code2: "normalUploadTimeSet",
        id: "800021",
        name: "normalUploadTimeSet",
        order: 0,
        parentId: "80002",
        parentMenu: "reviewTime",
        title: "报送及审核时间设置",
        url: "/auditorExamptionConfirm/filingsManage/normalUploadTimeSet"
      },
      {
        code: "/auditorExamptionConfirm/reviewTime/zgzxdeskTop",
        component: "auditorExamptionConfirm/reviewTime/zgzxdeskTop",
        code2: "zgzxdeskTop",
        id: "800022",
        name: "zgzxdeskTop",
        order: 0,
        parentId: "80002",
        parentMenu: "reviewTime",
        title: "报送及审核时间查看",
        url: "/auditorExamptionConfirm/reviewTime/zgzxdeskTop"
      },
    ]
  },
  {
    code: "/auditorExamptionConfirm/normalSmsSend",
    component: "auditorExamptionConfirm/normalSmsSend",
    code2: "normalSmsSend",
    id: "80003",
    name: "80003",
    order: 0,
    parentId: "8000",
    parentMenu: "normal",
    title: "短信发送管理",
    url: "/auditorExamptionConfirm/normalSmsSend"
  },



  {
    code: "/auditorExamptionConfirm/normalData",
    component: "auditorExamptionConfirm/normalData",
    code2: "normalData",
    id: "80004",
    name: "免试认定数据管理",
    order: 0,
    parentId: "8000",
    parentMenu: "normal",
    title: "免试认定数据管理",
    path: "/auditorExamptionConfirm/normalData",
    child: [
      {
        code: "/auditorExamptionConfirm/normalData/normalPreServiceSysTeacher",
        component: "auditorExamptionConfirm/normalData/normalPreServiceSysTeacher",
        code2: "normalPreServiceSysTeacher",
        id: "800041",
        name: "数据采集与审核",
        order: 0,
        parentId: "80004",
        parentMenu: "normalData",
        title: "数据采集与审核",
        url: "/auditorExamptionConfirm/normalData/normalPreServiceSysTeacher"
      },
      {
        code: "/auditorExamptionConfirm/normalData/normalTeacherImportLog",
        component: "auditorExamptionConfirm/normalData/normalTeacherImportLog",
        code2: "normalTeacherImportLog",
        id: "800042",
        name: "数据导入记录查询",
        order: 0,
        parentId: "80004",
        parentMenu: "normalData",
        title: "数据导入记录查询",
        url: "/auditorExamptionConfirm/normalData/normalTeacherImportLog"
      },
      {
        code: "/auditorExamptionConfirm/normalData/normalTeacherAllWorkList",
        component: "auditorExamptionConfirm/normalData/normalTeacherAllWorkList",
        code2: "normalTeacherAllWorkList",
        id: "800043",
        name: "数据报送统计",
        order: 0,
        parentId: "80004",
        parentMenu: "normalData",
        title: "数据报送统计",
        url: "/auditorExamptionConfirm/normalData/normalTeacherAllWorkList"
      },

    ]
  },

  {
    code: "/auditorExamptionConfirm/normalSubjectRuleFile",
    component: "auditorExamptionConfirm/normalSubjectRuleFile",
    code2: "normalSubjectRuleFile",
    id: "80005",
    name: "80005",
    order: 0,
    parentId: "8000",
    parentMenu: "normal",
    title: "科目三比对数据",
    url: "/auditorExamptionConfirm/normalSubjectRuleFile"
  },
]
},
  StaticSidebarRouters: [
    {
      code: "/HomeWorks",
      code2: "HomeWorks",
      component: "HomeWorks",
      Icon: {
        components: "svg-home",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      id: "10112",
      name: "工作台",
      order: 0,
      parentId: null,
      title: "工作台",
      path: "/HomeWorks"
    }

  ],
  sidebarRouters: [



    //基础数据
    {
      code: "basicModel",
      component: "basicModel",
      code2: "basicModel",
      id: "1002",
      name: "基础数据",
      Icon: {
        components: "svg-data",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      order: 0,
      parentId: null,
      title: "基础数据",
      path: "/basicModel",
      child: [
        {
          code: "/basicModel/BaseDictSubModel",
          component: "basicModel/BaseDictSubModel",
          code2: "BaseDictSubModel",
          id: "10021",
          name: "字典管理",
          order: 0,
          parentId: "1002",
          parentMenu: "basicModel",
          title: "字典管理",
          url: "/basicModel/BaseDictSubModel"
        },

        /*{
          code: "/basicModel/BaseSubjectSubModel",
          component: "/basicModel/BaseSubjectSubModel",
          code2: "BaseSubjectSubModel",
          id: "10022",
          name: "任教学科管理",
          order: 0,
          parentId: "1002",
          parentMenu: "basicModel",
          title: "任教学科管理",
          path: "/basicModel/BaseSubjectSubModel",
          child: [
            {
              code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=1",
              component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
              code2: "BaseSubjectSubModel",
              id: "1",
              name: "幼儿园任教学科管理",
              order: 0,
              parentId: "10022",
              parentMenu: "/basicModel/BaseSubjectSubModel",
              title: "幼儿园任教学科管理",
              url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
            },
            {
              code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=2",
              component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
              code2: "BaseSubjectSubModel",
              id: "2",
              name: "小学任教学科管理",
              order: 0,
              parentId: "10022",
              parentMenu: "/basicModel/BaseSubjectSubModel",
              title: "小学任教学科管理",
              url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"

              // code:"/basicModel/BaseSubjectSubModel",
              // component: "basicModel/BaseSubjectSubModel",
              // code2:"BaseSubjectSubModel",
              // id: "2",
              // name:"小学任教学科管理",
              // order:0,
              // parentId:"10022",
              // parentMenu:"BaseSubjectSubModel",
              // title:"小学任教学科管理",
              // url:"/basicModel/BaseSubjectSubModel"
            },
            {
              code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=3",
              component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
              code2: "BaseSubjectSubModel",
              id: "3",
              name: "初中任教学科管理",
              order: 0,
              parentId: "10022",
              parentMenu: "BaseSubjectSubModel",
              title: "初中任教学科管理",
              url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
            },
            {
              code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=4",
              component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
              code2: "BaseSubjectSubModel",
              id: "4",
              name: "高中任教学科管理",
              order: 0,
              parentId: "10022",
              parentMenu: "BaseSubjectSubModel",
              title: "高中任教学科管理",
              url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
            },
            {
              code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=5",
              component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
              code2: "BaseSubjectSubModel",
              id: "5",
              name: "中职中专任教学科管理",
              order: 0,
              parentId: "10022",
              parentMenu: "BaseSubjectSubModel",
              title: "中职中专任教学科管理",
              url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
            },
            {
              code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=6",
              component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
              code2: "BaseSubjectSubModel",
              id: "6",
              name: "高校任教学科管理",
              order: 0,
              parentId: "10022",
              parentMenu: "BaseSubjectSubModel",
              title: "高校任教学科管理",
              url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
            }
          ]
        },*/

        {
          code: "/basicModel/InstitutionalUsers",
          component: "basicModel/InstitutionalUsers",
          code2: "InstitutionalUsers",
          id: "10021",
          name: "机构和用户管理",
          order: 0,
          parentId: "1002",
          parentMenu: "basicModel",
          title: "机构和用户管理",
          path: "/basicModel/InstitutionalUsers",
          child: [
            {
              code: "/basicModel/InstitutionalUsers/BaseOrgSubModel",
              component: "basicModel/InstitutionalUsers/BaseOrgSubModel",
              code2: "BaseOrgSubModel",
              id: "10031",
              name: "机构管理",
              order: 0,
              parentId: "1002",
              parentMenu: "InstitutionalUsers",
              title: "机构管理",
              url: "/basicModel/InstitutionalUsers/BaseOrgSubModel"
            },
            {
              code: "/basicModel/InstitutionalUsers/BaseOrgHisoryLogSubModel",
              component: "basicModel/InstitutionalUsers/BaseOrgHisoryLogSubModel",
              code2: "BaseOrgHisoryLogSubModel",
              id: "10032",
              name: "机构管理日志",
              order: 0,
              parentId: "1002",
              parentMenu: "InstitutionalUsers",
              title: "机构管理日志",
              url: "/basicModel/InstitutionalUsers/BaseOrgHisoryLogSubModel"
            },
            {
              code: "/basicModel/InstitutionalUsers/BaseOrgCreditSubModel",
              component: "无",
              code2: "RecognizedCredit",
              id: "10033",
              name: "认定机构统一社会信用代码管理",
              order: 0,
              parentId: "1002",
              parentMenu: "InstitutionalUsers",
              title: "认定机构统一社会信用代码管理",
              url: "无"
            },

            {
              code: "/basicModel/InstitutionalUsers/employeeListManage",
              /*code2:"userManager",userList*/
              code2: "userManageList",
              component: "employeeListManage",
              id: "10071",
              name: "用户管理",
              order: 1,
              parentId: "1002",
              parentMenu: "InstitutionalUsers",
              title: "用户管理",
              path: "basicModel/InstitutionalUsers/employeeListManage"
            },
            {
              code: "/basicModel/InstitutionalUsers/roleListManage",
              /*code2:"roleManager",roleListManager*/
              code2: "roleListManager",
              component: "roleListManage",
              id: "10072",
              name: "角色权限管理",
              order: 2,
              parentId: "1002",
              parentMenu: "InstitutionalUsers",
              title: "角色权限管理",
              path: "basicModel/InstitutionalUsers/roleListManage"
            },
            {
              code: "/basicModel/InstitutionalUsers/RmsUsbKeySubModel",
              component: "basicModel/InstitutionalUsers/RmsUsbKeySubModel",
              /*code2:"RmsUsbKeySubModel",*/
              code2: "RmsUsbKeySubModelManage",
              id: "10073",
              name: "USBKey管理",
              order: 0,
              parentId: "1002",
              parentMenu: "InstitutionalUsers",
              title: "USBKey管理",
              url: "/basicModel/InstitutionalUsers/RmsUsbKeySubModel"
            },
            {
              code: "/basicModel/InstitutionalUsers/RmsUsbKeySubUserModel",
              component: "basicModel/InstitutionalUsers/RmsUsbKeySubUserModel",
              code2: "RmsUsbKeySubUserModelManage",
              id: "10074",
              name: "用户USBKey管理",
              order: 0,
              parentId: "1002",
              parentMenu: "InstitutionalUsers",
              title: "用户USBKey管理",
              url: "/basicModel/InstitutionalUsers/RmsUsbKeySubUserModel"
            },
          ]
        },
        {
          code: "/basicModel/ConfirmationPointQuery",
          component: "basicModel/ConfirmationPointQuery",
          code2: "ConfirmationPointQuery",
          id: "10028",
          name:"查询认定确认点用户",
          order:0,
          parentId:"1002",
          parentMenu:"basicModel",
          title:"查询认定确认点用户",
          url:"/basicModel/ConfirmationPointQuery"
        },
        {
          code: "/basicModel/EnrollConfirmationPointQuery",
          component: "basicModel/EnrollConfirmationPointQuery",
          code2: "EnrollConfirmationPointQuery",
          id: "10028",
          name:"查询定期注册确认点用户",
          order:0,
          parentId:"1002",
          parentMenu:"basicModel",
          title:"查询定期注册确认点用户",
          url:"/basicModel/EnrollConfirmationPointQuery"
        },

        // {
        //   code: "/basicModel/QualificationList",
        //   component: "basicModel/QualificationList",
        //   code2: "QualificationList",
        //   id: "10029",
        //   name:"资格考试合格名单",
        //   order:0,
        //   parentId:"1002",
        //   parentMenu:"basicModel",
        //   title:"资格考试合格名单",
        //   url:"/basicModel/QualificationList"
        // },

        {
          code: "/basicModel/LocaleSubModel",
          component: "basicModel/LocaleSubModel",
          code2: "LocaleSubModel",
          id: "20031",
          name: "认定确认点管理",
          order: 0,
          parentId: "1002",
          parentMenu: "basicModel",
          title: "认定确认点管理",
          url: "/register/LocaleSubModel"
        },

        // {
        //   code: "/basicModel/BaseCollegeSubModel",
        //   component: "basicModel/BaseCollegeSubModel",
        //   code2: "BaseCollegeSubModel",
        //   id: "10023",
        //   name: "毕业学校",
        //   order: 0,
        //   parentId: "1002",
        //   parentMenu: "model2",
        //   title: "毕业学校",
        //   url: "/basicModel/BaseCollegeSubModel"
        // },
        //
        // {
        //   code: "/basicModel/BaseMajorSubModel",
        //   component: "basicModel/BaseMajorSubModel",
        //   code2: "BaseMajorSubModel",
        //   id: "10025",
        //   name: "所学专业",
        //   order: 0,
        //   parentId: "1002",
        //   parentMenu: "basicModel",
        //   title: "所学专业",
        //   url: "/basicModel/BaseMajorSubModel"
        // },
        {
          code: "/basicModel/UserSubModel",
          component: "basicModel/UserSubModel",
          code2: "UserSubModel",
          id: "20033",
          name: "认定确认用户管理",
          order: 0,
          parentId: "1002",
          parentMenu: "basicModel",
          title: "认定确认用户管理",
          url: "/register/UserSubModel"
        },
        // {
        //   code: "/basicModel/UserNormal",
        //   component: "basicModel/UserNormal",
        //   code2: "UserNormal",
        //   id: "20055",
        //   name: "高校用户管理",
        //   order: 0,
        //   parentId: "1002",
        //   parentMenu: "basicModel",
        //   title: "高校用户管理",
        //   url: "/register/UserNormal"
        // },
        {
          // code: "/basicModel/MyOrgSubModel",
          code: "/basicModel/SiteOrgSubModel",
          component: "basicModel/MyOrgSubModel",
          code2: "MyOrgSubModel",
          id: "30032",
          name: "认定机构公示信息管理",
          order: 0,
          parentId: "1002",
          parentMenu: "basicModel",
          title: "认定机构公示信息管理",
          url: "/basicModel/SiteOrgSubModel"
        },



        {
          code: "/basicModel/EnrollLocaleSubModel",
          component: "basicModel/EnrollLocaleSubModel",
          code2: "EnrollLocaleSubModel",
          id: "20032",
          name: "定期注册确认点管理",
          order: 0,
          parentId: "1002",
          parentMenu: "basicModel",
          title: "定期注册确认点管理",
          url: "/register/EnrollLocaleSubModel"
        },
        {
          code: "/basicModel/EnrollLocaleUserSubModel",
          component: "basicModel/EnrollLocaleUserSubModel",
          code2: "EnrollLocaleUserSubModel",
          id: "20034",
          name: "定期注册确认用户管理",
          order: 0,
          parentId: "1002",
          parentMenu: "basicModel",
          title: "定期注册确认用户管理",
          url: "/register/EnrollLocaleUserSubModel"
        },


        {
          code: "/basicModel/EnrollSiteOrgSubModel",
          component: "basicModel/EnrollSiteOrgSubModel",
          code2: "RegisterMyOrgSubModel",
          id: "30033",
          name: "定期注册注册机构公示信息管理",
          order: 0,
          parentId: "1002",
          parentMenu: "basicModel",
          title: "定期注册机构公示信息管理",
          url: "/basicModel/EnrollSiteOrgSubModel"
        },
        {
            code: "/basicModel/BaseOrgSchoolSubModel",
            component: "basicModel/BaseOrgSchoolSubModel",
            code2: "BaseOrgSchoolSubModel",
            id: "10024",
            name: "定期注册中小学信息管理",
            order: 0,
            parentId: "1002",
            parentMenu: "model2",
            title: "定期注册中小学信息管理",
            url: "/basicModel/BaseOrgSchoolSubModel"
          },

        {
          code: "/basicModel/BaseOrgDocSubModel",
          component: "basicModel/BaseOrgDocSubModel",
          code2: "BaseOrgDocSubModel",
          id: "10026",
          name: "机构导出权限备案",
          order: 0,
          parentId: "1002",
          parentMenu: "model2",
          title: "机构导出权限备案",
          url: "/basicModel/BaseOrgDocSubModel"
        },


        {
          code: "/basicModel/QRBaseOrgDocSubModel",
          component: "basicModel/QRBaseOrgDocSubModel",
          code2: "QRBaseOrgDocSubModel",
          id: "20041",
          name: "确认点导出权限备案",
          order: 0,
          parentId: "2000",
          parentMenu: "model2",
          title: "确认点导出权限备案",
          url: "/basicModel/QRBaseOrgDocSubModel"
        },


        {
          code: "/basicModel/QRAudBaseOrgDocSubModel",
          component: "basicModel/QRAudBaseOrgDocSubModel",
          code2: "QRAudBaseOrgDocSubModel",
          id: "10030",
          name: "确认点导出权限备案审批",
          order: 0,
          parentId: "1002",
          parentMenu: "model2",
          title: "确认点导出权限备案审批",
          url: "/basicModel/QRAudBaseOrgDocSubModel"
        },

        // {
        //   code: "/basicModel/NumberOfManagers",
        //   component: "basicModel/NumberOfManagers",
        //   code2: "NumberOfManagers",
        //   id: "30034",
        //   name: "管理注册人数",
        //   order: 0,
        //   parentId: "1002",
        //   parentMenu: "basicModel",
        //   title: "管理注册人数",
        //   url: "/basicModel/NumberOfManagers"
        // },
      ]
    },

    //地方平台对接管理
    {
      code: "platformDocking",
      component: "platformDocking",
      code2: "platformDocking",
      id: "18000",
      name: "地方平台对接管理",
      Icon: {
        components: "svg-file-editing-one",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      order: 0,
      parentId: null,
      title: "地方平台对接管理",
      path: "/platformDocking",

      child: [

        // {
        //   code: "/platformDocking/RealNameVerification?addr=/ssoauth/auth.html",
        //   component: "无",
        //   code2: "basicRealNameVerification",
        //   id: "18010",
        //   name: "实名核验审核",
        //   order: 0,
        //   parentId: "18000",
        //   parentMenu: "platformDocking",
        //   title: "实名核验审核",
        //   url: "无"
        // },
        // {
        //   code: "/platformDocking/RealNameVerification?addr=/ssoauth/authChanges.html",
        //   component: "无",
        //   code2: "basicRealNameVerification1",
        //   id: "18020",
        //   name: "实名核验数据变化情况",
        //   order: 0,
        //   parentId: "18000",
        //   parentMenu: "platformDocking",
        //   title: "实名核验数据变化情况",
        //   url: "无"
        // },
        {
          code: "/platformDocking/GBSwitch",
          component: "platformDocking/GBSwitch",
          code2: "basicRealNameVerification2",
          id: "18010",
          name: "国办接口开关管理",
          order: 0,
          parentId: "18000",
          parentMenu: "platformDocking",
          title: "国办接口开关管理",
          url: "/platformDocking/GBSwitch"
        },


        // {
        //   code: "/platformDocking/aaaaa",
        //   component: "/platformDocking/aaaaa",
        //   code2: "RExceptionHandling",
        //   id: "18010",
        //   name: "国办接口开关管理",
        //   order: 0,
        //   parentId: "18000",
        //   parentMenu: "platformDocking",
        //   title: "国办接口开关管理",
        //   url: "/platformDocking/aaaaa"
        // },
        // {
        //   code: "/platformDocking/RealNameVerification?addr=/gbsync/gbDailyLog.html",
        //   component: "无",
        //   code2: "basicRealNameVerification3",
        //   id: "18040",
        //   name: "国办接口调用情况(明细)",
        //   order: 0,
        //   parentId: "18000",
        //   parentMenu: "platformDocking",
        //   title: "国办接口调用情况(明细)",
        //   url: "无"
        // },
        // {
        //   code: "/platformDocking/RealNameVerification?addr=/gbsync/gbNumLog.html",
        //   component: "无",
        //   code2: "basicRealNameVerification4",
        //   id: "18050",
        //   name: "国办接口调用情况(汇总)",
        //   order: 0,
        //   parentId: "18000",
        //   parentMenu: "platformDocking",
        //   title: "国办接口调用情况(汇总)",
        //   url: "无"
        // },
        // {
        //   code: "/platformDocking/RealNameVerification?addr=/gbsync/gbPostBackLog.html",
        //   component: "无",
        //   code2: "basicRealNameVerification5",
        //   id: "18060",
        //   name: "办件数据回传接口调用情况",
        //   order: 0,
        //   parentId: "18000",
        //   parentMenu: "platformDocking",
        //   title: "办件数据回传接口调用情况",
        //   url: "无"
        // },
        {
          code: "/platformDocking/RExceptionHandling",
          component: "/platformDocking/RExceptionHandling",
          code2: "RExceptionHandling",
          id: "18070",
          name: "办件数据回传异常数据处理",
          order: 0,
          parentId: "18000",
          parentMenu: "platformDocking",
          title: "办件数据回传异常数据处理",
          url: "/platformDocking/RExceptionHandling"
        },
        // {
        //   code: "/platformDocking/RealNameVerification?addr=/gbsync/gbStatistics.html",
        //   component: "无",
        //   code2: "basicRealNameVerification7",
        //   id: "18080",
        //   name: "办件数据办结管理",
        //   order: 0,
        //   parentId: "18000",
        //   parentMenu: "platformDocking",
        //   title: "办件数据办结管理",
        //   url: "无"
        // },
      ]

    },

    //认定管理
    {
      code: "register",
      component: "register",
      code2: "register",
      id: "2000",
      name: "认定管理",
      Icon: {
        components: "svg-file-editing-one",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      order: 0,
      parentId: null,
      title: "认定管理",
      path: "/register",
      child: [
        {
          code: "/register/CertBatchSubModel",
          component: "register/CertBatchSubModel",
          code2: "CertBatchSubModel2",
          id: "20021",
          name: "设置认定批次",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "设置认定批次",
          url: "/register/CertBatchSubModel"
        },
        {
          code: "/register/ZgzxProvinceBatchSubModel",
          component: "register/ZgzxProvinceBatchSubModel",
          code2: "ZgzxProvinceBatchSubModel",
          id: "20023",
          name: "审批认定计划",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "审批认定计划",
          url: "/register/ZgzxProvinceBatchSubModel"
        },

        {
          code: "/register/OrgViewOrgBatchSubModel",
          component: "register/OrgViewOrgBatchSubModel",
          code2: "OrgViewOrgBatchSubModel",
          id: "20025",
          name: "查看认定计划",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "查看认定计划",
          url: "/register/OrgViewOrgBatchSubModel"
        },
        {
          code: "/register/ProvinceBatchSubModel",
          component: "register/ProvinceBatchSubModel",
          code2: "ProvinceBatchSubModel",
          id: "20027",
          name: "设置本省认定计划",
          order: 0,
          parentId: "2000",
          parentMenu: "model2",
          title: "设置本省认定计划",
          url: "/register/ProvinceBatchSubModel"
        },
        // {
        //   code:"/register/ProvinceBatchPostponeSubModel",
        //   component: "register/ProvinceBatchSubModel",
        //   code2:"ProvinceBatchSubModel",
        //   id: "20027",
        //   name:"管理本省认定计划",
        //   order:0,
        //   parentId:"2000",
        //   parentMenu:"model2",
        //   title:"管理本省认定计划",
        //   url:"/register/ProvinceBatchSubModel"
        // },
        {
          code: "/register/OrgBatchSubModel",
          component: "register/OrgBatchSubModel",
          code2: "OrgBatchSubModel",
          id: "20029",
          name: "设置本机构认定计划",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "设置本机构认定计划",
          url: "/register/OrgBatchSubModel"
        },
        {
          code: "/register/ChildOrgBatchSubModel",
          component: "register/ChildOrgBatchSubModel",
          code2: "SubordinateOrgPlan",
          id: "20029",
          name: "管理下级机构认定计划",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "管理下级机构认定计划",
          url: "/register/ChildOrgBatchSubModel"
        },

        {
          code: "/register/LocaleSetSubModel",
          component: "register/LocaleSetSubModel",
          code2: "LocaleSetSubModel",
          id: "20035",
          name: "安排确认点工作",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "安排确认点工作",
          url: "/register/LocaleSetSubModel"
        },

        {
          code: "/register/RegistrationSubModel",
          component: "register/RegistrationSubModel",
          code2: "OrgBatchTimeSubModel",
          id: "20037",
          name: "核对网络填报数据",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "核对网络填报数据",
          url: "/register/RegistrationSubModel"
        },
        {
          code: "/register/SubRegistrationAudSubModel",
          component: "register/SubRegistrationAudSubModel",
          code2: "getSubRegistrations",
          id: "20041",
          name: "查看认定数据",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "查看认定数据",
          url: "/register/SubRegistrationAudSubModel"
        },



        {
          code: "/register/RegistrationOtherSubModel",
          component: "register/RegistrationOtherSubModel",
          code2: "RegistrationOtherSubModel",
          id: "20039",
          name: "查看其他确认点数据",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "查看其他确认点数据",
          url: "/register/RegistrationOtherSubModel"
        },
        // {
        //   code: "/register/QRBaseOrgDocSubModel",
        //   component: "register/QRBaseOrgDocSubModel",
        //   code2: "QRBaseOrgDocSubModel",
        //   id: "20041",
        //   name: "确认点导出权限备案",
        //   order: 0,
        //   parentId: "2000",
        //   parentMenu: "register",
        //   title: "确认点导出权限备案",
        //   url: "/register/QRBaseOrgDocSubModel"
        // },
        {
          code: "/register/RegistrationAudSubModel",
          component: "register/RegistrationAudSubModel",
          code2: "RegistrationAudSubModel",
          id: "20042",
          name: "认定审批",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "认定审批",
          url: "/register/RegistrationAudSubModel"
        },
        {
          code:"/register/OrgBatchQueryApplySubModel",
          component: "register/OrgBatchQueryApplySubModel",
          code2:"OrgBatchQueryApplySubModel",
          id: "20052",
          name:"申请提供证书验证",
          order:0,
          parentId:"2000",
          parentMenu:"register",
          title:"申请提供证书验证",
          url:"/register/OrgBatchQueryApplySubModel"
        },

        {
          code: "/register/CompletionFinishModel",
          component: "register/CompletionFinishModel",
          code2: "CompletionFinishModel",
          id: "20049",
          name: "提交政务平台办结数据",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "提交政务平台办结数据",
          url: "/register/CompletionFinishModel"
        },
        {
          code:"/register/ProcessingDataReturn",
          component: "register/ProcessingDataReturn",
          code2:"ProcessingDataReturn",
          id: "20003",
          name:"查询办结操作记录",
          order:0,
          parentId:"2055",
          parentMenu:"register",
          title:"查询办结操作记录",
          url:"/register/ProcessingDataReturn"
        },
        {
          code: "/register/ProcessingData",
          component: "register/ProcessingData",
          code2: "RegistrationEndModel",
          id: "20003",
          name: "办件数据回传处理统计",
          order: 0,
          parentId: "2057",
          parentMenu: "register",
          title: "办件数据回传处理统计",
          url: "/register/ProcessingData"
        },
        {
          code:"/register/OrgBatchEndApplySubModel",
          component: "register/OrgBatchEndApplySubModel",
          code2:"OrgBatchEndApplySubModel",
          id: "20051",
          name:"申请结束认定计划",
          order:0,
          parentId:"2000",
          parentMenu:"register",
          title:"申请结束认定计划",
          url:"/register/OrgBatchEndApplySubModel"
        },
        {
          code:"/register/OrgBatchEndSubModel",
          component: "register/OrgBatchEndSubModel",
          code2:"OrgBatchEndSubModel",
          id: "20053",
          name:"结束认定计划",
          order:0,
          parentId:"2000",
          parentMenu:"register",
          title:"结束认定计划",
          url:"/register/OrgBatchEndSubModel"
        },
        {
          code: "/register/getOtherOrgRegistrations",
          component: "register/getOtherOrgRegistrations",
          code2: "getOtherOrgRegistrations",
          id: "20040",
          name: "查询全国认定数据",
          order: 0,
          parentId: "2000",
          parentMenu: "register",
          title: "查询全国认定数据",
          url: "/register/getOtherOrgRegistrations"
        },


      ]
    },
    {
      code: "auditorExamptionConfirm",
      component: "auditorExamptionConfirm",
      code2: "normal",
      id: "8000",
      name: "免试认定数据报送",
      Icon: {
        components: "svg-data",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      order: 0,
      parentId: null,
      title: "免试认定数据报送",
      path: "/auditorExamptionConfirm",
      child: [
        {
          code: "/auditorExamptionConfirm/filingsManage",
          component: "auditorExamptionConfirm/filingsManage",
          code2: "filings",
          id: "80001",
          name: "备案管理",
          order: 0,
          parentId: "8000",
          parentMenu: "normal",
          title: "备案管理",
          path: "/auditorExamptionConfirm/filingsManage",
          child: [
            {
              code: "/auditorExamptionConfirm/filingsManage/normaleProvinceLeader",
              component: "auditorExamptionConfirm/filingsManage/normaleProvinceLeader",
              code2: "normaleProvinceLeader",
              id: "800012",
              name: "改革工作组备案",
              order: 0,
              parentId: "80001",
              parentMenu: "filingsManage",
              title: "改革工作组备案",
              url: "/auditorExamptionConfirm/filingsManage/normaleProvinceLeader"
            },
            {
              code: "/auditorExamptionConfirm/filingsManage/schoolnormaleUniversity",
              component: "auditorExamptionConfirm/filingsManage/schoolnormaleUniversity",
              code2: "schoolnormaleUniversity",
              id: "80007",
              name: "80007",
              order: 0,
              parentId: "8000",
              parentMenu: "normal",
              title: "查看学校备案信息",
              url: "/auditorExamptionConfirm/filingsManage/schoolnormaleUniversity"
            },
            {
              code: "/auditorExamptionConfirm/filingsManage/normaleUniversity",
              component: "auditorExamptionConfirm/filingsManage/normaleUniversity",
              code2: "normaleUniversity",
              id: "800011",
              name: "免试认定高校备案",
              order: 0,
              parentId: "80001",
              parentMenu: "filingsManage",
              title: "免试认定高校备案",
              url: "/auditorExamptionConfirm/filingsManage/normaleUniversity"
            },
            {
              code: "/auditorExamptionConfirm/filingsManage/normalEduAbilityAssess",
              component: "auditorExamptionConfirm/filingsManage/normalEduAbilityAssess",
              code2: "normalEduAbilityAssess",
              id: "800013",
              name: "教育教学能力考核办法备案",
              order: 0,
              parentId: "80001",
              parentMenu: "filingsManage",
              title: "教育教学能力考核办法备案",
              url: "/auditorExamptionConfirm/filingsManage/normalEduAbilityAssess"
            },

            {
              code: "/auditorExamptionConfirm/filingsManage/normaleUniversityRoster",
              component: "auditorExamptionConfirm/filingsManage/normaleUniversityRoster",
              code2: "normaleUniversityRoster",
              id: "800014",
              name: "免试高校及专业名单管理",
              order: 0,
              parentId: "80001",
              parentMenu: "filingsManage",
              title: "免试高校及专业名单管理",
              url: "/auditorExamptionConfirm/filingsManage/normaleUniversityRoster"
            },
          ]
        },



        {
          code: "/auditorExamptionConfirm/reviewTime",
          component: "auditorExamptionConfirm/reviewTime",
          code2: "reviewTime",
          id: "80002",
          name: "数据报送及审核时间管理",
          order: 0,
          parentId: "8000",
          parentMenu: "normal",
          title: "数据报送及审核时间管理",
          path: "/auditorExamptionConfirm/reviewTime",
          child: [
            {
              code: "/auditorExamptionConfirm/reviewTime/NormalBatch",
              component: "auditorExamptionConfirm/reviewTime/NormalBatch",
              code2: "NormalBatch",
              id: "800098",
              name: "NormalBatch",
              order: 0,
              parentId: "80002",
              parentMenu: "reviewTime",
              title: "报送批次设置",
              url: "/auditorExamptionConfirm/filingsManage/NormalBatch"
            },
            {
              code: "/auditorExamptionConfirm/reviewTime/normalUploadTimeSet",
              component: "auditorExamptionConfirm/reviewTime/normalUploadTimeSet",
              code2: "normalUploadTimeSet",
              id: "800021",
              name: "normalUploadTimeSet",
              order: 0,
              parentId: "80002",
              parentMenu: "reviewTime",
              title: "报送及审核时间设置",
              url: "/auditorExamptionConfirm/filingsManage/normalUploadTimeSet"
            },
            {
              code: "/auditorExamptionConfirm/reviewTime/zgzxdeskTop",
              component: "auditorExamptionConfirm/reviewTime/zgzxdeskTop",
              code2: "zgzxdeskTop",
              id: "800022",
              name: "zgzxdeskTop",
              order: 0,
              parentId: "80002",
              parentMenu: "reviewTime",
              title: "报送及审核时间查看",
              url: "/auditorExamptionConfirm/reviewTime/zgzxdeskTop"
            },


          ]
        },

        {
          code: "/auditorExamptionConfirm/zgzxdeskTop2",
          component: "auditorExamptionConfirm/zgzxdeskTop2",
          code2: "zgzxdeskTop2",
          id: "80006",
          name: "80006",
          order: 0,
          parentId: "8000",
          parentMenu: "normal",
          title: "数据报送及审核时间查看",
          url: "/auditorExamptionConfirm/zgzxdeskTop2"
        },



        {
          code: "/auditorExamptionConfirm/schoolnormalEduAbilityAssess",
          component: "auditorExamptionConfirm/schoolnormalEduAbilityAssess",
          code2: "normalEduAbilityAssess2",
          id: "80008",
          name: "80008",
          order: 0,
          parentId: "8000",
          parentMenu: "normal",
          title: "教育教学能力考核办法备案",
          url: "/auditorExamptionConfirm/schoolnormalEduAbilityAssess"
        },

        {
          code: "/auditorExamptionConfirm/normalSmsSend",
          component: "auditorExamptionConfirm/normalSmsSend",
          code2: "normalSmsSend",
          id: "80003",
          name: "80003",
          order: 0,
          parentId: "8000",
          parentMenu: "normal",
          title: "短信发送管理",
          url: "/auditorExamptionConfirm/normalSmsSend"
        },


        {
          code: "/auditorExamptionConfirm/UserNormal",
          component: "auditorExamptionConfirm/UserNormal",
          code2: "UserNormal",
          id: "20055",
          name: "高校用户管理",
          order: 0,
          parentId: "1002",
          parentMenu: "basicModel",
          title: "高校用户管理",
          url: "/register/UserNormal"
        },



        {
          code: "/auditorExamptionConfirm/normalData",
          component: "auditorExamptionConfirm/normalData",
          code2: "normalData",
          id: "80004",
          name: "免试认定数据管理",
          order: 0,
          parentId: "8000",
          parentMenu: "normal",
          title: "免试认定数据管理",
          path: "/auditorExamptionConfirm/normalData",
          child: [
            {
              code: "/auditorExamptionConfirm/normalData/normalPreServiceSysTeacher",
              component: "auditorExamptionConfirm/normalData/normalPreServiceSysTeacher",
              code2: "normalPreServiceSysTeacher",
              id: "800041",
              name: "数据采集与审核",
              order: 0,
              parentId: "80004",
              parentMenu: "normalData",
              title: "数据采集与审核",
              url: "/auditorExamptionConfirm/normalData/normalPreServiceSysTeacher"
            },
            {
              code: "/auditorExamptionConfirm/normalData/normalTeacherImportLog",
              component: "auditorExamptionConfirm/normalData/normalTeacherImportLog",
              code2: "normalTeacherImportLog",
              id: "800042",
              name: "数据导入记录查询",
              order: 0,
              parentId: "80004",
              parentMenu: "normalData",
              title: "数据导入记录查询",
              url: "/auditorExamptionConfirm/normalData/normalTeacherImportLog"
            },
            {
              code: "/auditorExamptionConfirm/normalData/normalTeacherAllWorkList",
              component: "auditorExamptionConfirm/normalData/normalTeacherAllWorkList",
              code2: "normalTeacherAllWorkList",
              id: "800043",
              name: "数据报送统计",
              order: 0,
              parentId: "80004",
              parentMenu: "normalData",
              title: "数据报送统计",
              url: "/auditorExamptionConfirm/normalData/normalTeacherAllWorkList"
            },

            {
              code: "/auditorExamptionConfirm/normalData/schooljylnormalPreServiceTeacher",
              component: "auditorExamptionConfirm/normalData/schooljylnormalPreServiceTeacher",
              code2: "normalPreServiceTeacher2",
              id: "800044",
              name: "教育类研究生数据管理",
              order: 0,
              parentId: "80004",
              parentMenu: "normalData",
              title: "教育类研究生数据管理",
              url: "/auditorExamptionConfirm/normalData/schooljylnormalPreServiceTeacher"
            },

            {
              code: "/auditorExamptionConfirm/normalData/schoolgfnormalPreServiceTeacher",
              component: "auditorExamptionConfirm/normalData/schoolgfnormalPreServiceTeacher",
              code2: "normalPreServiceTeacher3",
              id: "800045",
              name: "师范生数据管理",
              order: 0,
              parentId: "80004",
              parentMenu: "normalData",
              title: "师范生数据管理",
              url: "/auditorExamptionConfirm/normalData/schoolgfnormalPreServiceTeacher"
            },
          ]
        },

        {
          code: "/auditorExamptionConfirm/normalSubjectRuleFile",
          component: "auditorExamptionConfirm/normalSubjectRuleFile",
          code2: "normalSubjectRuleFile",
          id: "80005",
          name: "80005",
          order: 0,
          parentId: "8000",
          parentMenu: "normal",
          title: "科目三比对数据",
          url: "/auditorExamptionConfirm/normalSubjectRuleFile"
        },



      ]
    },

    //定期注册
    {
      code:"enrollModel",
      component: "enrollModel",
      code2:"enrollModel",
      id: "3000",
      name:"定期注册管理",
      Icon: {
        components: "svg-file-editing-one",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      order:0,
      parentId:null,
      title:"定期注册管理",
      path:"/enrollModel",
      child: [
        {
          code:"/enrollModel/CertBatchSubModel",
          component: "enrollModel/CertBatchSubModel",
          code2:"EnrollCertBatchSubModel",
          id: "30001",
          name:"设置定期注册批次",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"设置定期注册批次",
          url:"/enrollModel/CertBatchSubModel"
        },
        {
          code:"/enrollModel/ApproveEnrollPlan",
          component: "enrollModel/ApproveEnrollPlan",
          code2:"EnrollApproveProvinceBatchSubModel",
          id: "30004",
          name:"审批定期注册计划",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"审批定期注册计划",
          url:"/enrollModel/ApproveEnrollPlan"
        },
        {
          code:"/enrollModel/OrgBatchCitySubModel",
          component: "enrollModel/OrgBatchCitySubModel",
          code2:"EnrollOrgAndDownOrgInfoSubModel",
          id: "30009",
          name:"查看定期注册计划",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"查看定期注册计划",
          url:"/enrollModel/OrgBatchCitySubModel"
        },
        {
          code:"/enrollModel/ProvinceBatchSubModel",
          component: "enrollModel/ProvinceBatchSubModel",
          code2:"EnrollSetSelfProvinceBatchSubModel",
          id: "30003",
          name:"设置本省注册计划",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"设置本省注册计划",
          url:"/enrollModel/ProvinceBatchSubModel"
        },

        {
          code:"/enrollModel/OrgBatchSubModel",
          component: "enrollModel/OrgBatchSubModel",
          code2:"EnrollSelfOrgBatchSubModel",
          id: "30009",
          name:"设置本机构注册计划",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"设置本机构注册计划",
          url:"/enrollModel/OrgBatchSubModel"
        },
        {
          code:"/enrollModel/RegisterSubordinateOrgPlan",
          component: "enrollModel/RegisterSubordinateOrgPlan",
          code2:"RegisterSubordinateOrgPlan",
          id: "30009",
          name:"管理下级机构定期注册计划",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"管理下级机构定期注册计划",
          url:"/enrollModel/RegisterSubordinateOrgPlan"
        },


        {
          code:"/enrollModel/LocaleSetSubModel",
          component: "enrollModel/LocaleSetSubModel",
          code2:"EnrollLocaleSetSubModel",
          id: "30011",
          name:"安排确认点工作",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"安排确认点工作",
          url:"/enrollModel/LocaleSetSubModel"
        },


        {
          code:"/enrollModel/EnrollmentSubModel",
          component: "enrollModel/EnrollmentSubModel",
          code2:"EnrollCheckNetWorkDataSubModel",
          id: "30017",
          name:"核对网络填报数据",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"核对网络填报数据",
          url:"/enrollModel/EnrollmentSubModel"
        },
        {
          code:"/enrollModel/EnrollCityAudSubModel",
          component: "enrollModel/EnrollCityAudSubModel",
          code2:"EnrollAgainCheckAudSubModel",
          id: "30022",
          name:"定期注册审批",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"定期注册审批",
          url:"/enrollModel/EnrollCityAudSubModel"
        },
        {
          code:"/enrollModel/EnrollmentSubSubModel",
          component: "enrollModel/EnrollmentSubSubModel",
          code2:"EnrollmentSubSubModel",
          id: "30025",
          name:"查看定期注册数据",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"查看定期注册数据",
          url:"/enrollModel/EnrollmentSubSubModel"
        },


        {
          code:"/enrollModel/EnrollmentOtherSubModel",
          component: "enrollModel/EnrollmentOtherSubModel",
          code2:"EnrollmentOtherSubModel",
          id: "30025",
          name:"查询全国定期注册数据",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"查询全国定期注册数据",
          url:"/enrollModel/EnrollmentOtherSubModel"
        } ,

        {
          code:"/enrollModel/viewConfirmationPointData",
          component: "enrollModel/viewConfirmationPointData",
          code2:"viewConfirmationPointData",
          id: "30019",
          name:"查看其他确认点数据",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"查看其他确认点数据",
          url:"/enrollModel/viewConfirmationPointData"
        },




        {
          code:"/enrollModel/EnrollOrgBatchEndApplySubModel",
          component: "enrollModel/EnrollOrgBatchEndApplySubModel",
          code2:"EnrollOrgBatchEndApplySubModel",
          id: "30027",
          name:"申请结束定期注册计划",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"申请结束定期注册计划",
          url:"/enrollModel/EnrollOrgBatchEndApplySubModel"
        },
        {
          code:"/enrollModel/EnrollOrgBatchEndSubModel",
          component: "enrollModel/EnrollOrgBatchEndSubModel",
          code2:"EnrollOrgBatchEndSubModel",
          id: "30029",
          name:"结束定期注册计划",
          order:0,
          parentId:"3000",
          parentMenu:"enrollModel",
          title:"结束定期注册计划",
          url:"/enrollModel/EnrollOrgBatchEndSubModel"
        },
      ]
    },

    //证书及历史数据管理
    {
      code:"/historyDataManage",
      component: "certModel",
      code2:"historyDataManage",
      id: "5000",
      name:"证书及历史数据管理",
      Icon: {
        components: "svg-add",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      order:0,
      parentId:null,
      title:"证书及历史数据管理",
      path:"/historyDataManage",
      child: [
        {
          code:"/historyDataManage/CertSubModel",
          component: "historyDataManage/CertSubModel",
          code2:"CertSubModel",
          id: "50001",
          name:"教师资格证书管理",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"教师资格证书管理",
          url:"/historyDataManage/CertSubModel"
        },

        {
          code:"/historyDataManage/CertificateOfRegistration",
          component: "historyDataManage/CertificateOfRegistration",
          code2:"CertificateOfRegistration",
          id: "50002",
          name:"证书变更审批",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"证书变更审批",
          url:"/historyDataManage/CertificateOfRegistration"
        },

        {
          code:"/historyDataManage/CertChangeSubModel",
          component: "historyDataManage/CertChangeSubModel",
          code2:"CertChangeSubModel",
          id: "50003",
          name:"证书信息变更记录",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"证书信息变更记录",
          url:"/historyDataManage/CertChangeSubModel"
        },



        {
          code:"/historyDataManage/CertAdditionSubModel",
          component: "certModel/CertAdditionSubModel",
          code2:"CertAdditionSubModel",
          id: "50005",
          name:"证书补发换发管理",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"证书补发换发管理",
          url:"/historyDataManage/CertAdditionSubModel"
        },

        {
          code:"/historyDataManage/HistoryValidSubModel",
          component: "historyDataManage/IdentifyHistoricalData",
          code2:"queryHistoryValid",
          id: "50006",
          name:"查看认定历史数据",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"查看认定历史数据",
          url:"/historyDataManage/HistoryValidSubModel"
        },
        {
          code:"/historyDataManage/nationalHistoricalData",
          component: "historyDataManage/nationalHistoricalData",
          code2:"queryALLHistoryValid",
          id: "50007",
          name:"查询全国认定历史数据",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"查询全国认定历史数据",
          url:"/historyDataManage/nationalHistoricalData"
        },
        {
          code:"/historyDataManage/registeredCountryHistoricalData",
          component: "historyDataManage/registeredCountryHistoricalData",
          code2:"registeredCountryHistoricalData",
          id: "50007",
          name:"查询全国定期注册历史数据",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"查询全国定期注册历史数据",
          url:"/historyDataManage/registeredCountryHistoricalData"
        },
        //  原有的注释掉了
        {
          code:"/historyDataManage/EnrollHistorySubModel",
          component: "historyDataManage/EnrollHistorySubModel",
          code2:"EnrollHistorySubModel",
          id: "50010",
          name:"定期注册历史数据管理",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"定期注册历史数据管理",
          url:"/historyDataManage/EnrollHistorySubModel"
        },
        {
          code:"/historyDataManage/EnrollHistoryChangeAuditSubModel",
          component: "certModel/EnrollHistoryChangeAuditSubModel",
          code2:"EnrollHistoryChangeAuditSubModel",
          id: "50012",
          name:"定期注册历史数据变更审批",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"定期注册历史数据变更审批",
          url:"/historyDataManage/EnrollHistoryChangeAuditSubModel"
        },




        {
          code:"/historyDataManage/HistoryTempSubModel",
          component: "historyDataManage/HistoryTempSubModel",
          code2:"queryHistoryTemp",
          id: "50012",
          name:"认定非正式历史数据查询",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"认定非正式历史数据查询",
          url:"/historyDataManage/HistoryTempSubModel"
        },
        {
          code:"/historyDataManage/HistoryValidTempSubModel",
          component: "historyDataManage/HistoryValidTempSubModel",
          code2:"queryHistoryValidTemp",
          id: "50012",
          name:"广西2012年前认定数据查询",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"广西2012年前认定数据查询",
          url:"/historyDataManage/HistoryValidTempSubModel"
        },

        {
          code:"/historyDataManage/EnrollHistoryTempSubModel",
          component: "historyDataManage/EnrollHistoryTempSubModel",
          code2:"queryEnrollHistoryTemp",
          id: "50010",
          name:"定期注册非正式历史数据查询",
          order:0,
          parentId:"5000",
          parentMenu:"historyDataManage",
          title:"定期注册非正式历史数据查询",
          url:"/historyDataManage/EnrollHistoryTempSubModel"
        },


      ]
    },

    //限制库管理
    {
      code:"limitModel",
      component: "limitModelMenu",
      code2:"limitModelMenu",
      id: "6000",
      name:"限制库管理",
      Icon: {
        components: "svg-permissions",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      order:0,
      parentId:null,
      title:"限制库管理",
      path:"/limitModel",
      child: [
        {
          code:"/limitModel/LimitationInfoSubModel",
          component: "limitModel/LimitationInfoSubModel",
          code2:"LimitationInfoSubModel",
          id: "60031",
          name:"限制库管理",
          order:0,
          parentId:"6000",
          parentMenu:"limitModel",
          title:"限制库管理",
          url:"/limitModel/LimitationInfoSubModel"
        },
        {
          code:"/limitModel/LimitationInfoFuHeSubModel",
          component: "LimitationInfoFuHeSubModel",
          code2:"LimitationInfoFuHeSubModel",
          id: "50002",
          name:"限制库审批",
          order:0,
          parentId:"5000",
          parentMenu:"limitModel",
          title:"限制库审批",
          url:"/limitModel/LimitationInfoFuHeSubModel"
        },

        {
          code:"/limitModel/LimitationSubModel",
          component: "limitModel/LimitationSubModel",
          code2:"LimitationSubModel",
          id: "60031",
          name:"限制库发布初审",
          order:0,
          parentId:"6000",
          parentMenu:"limitModel",
          title:"限制库发布初审",
          url:"/limitModel/LimitationSubModel"
        },
        {
          code:"/limitModel/WfWorkflowAuditSubModel",
          component: "limitModel/WfWorkflowAuditSubModel",
          code2:"WfWorkflowAuditSubModel",
          id: "60032",
          name:"限制库发布审批",
          order:0,
          parentId:"6000",
          parentMenu:"limitModel",
          title:"限制库发布审批",
          url:"/limitModel/WfWorkflowAuditSubModel"
        },
        {
          // code:"/limitModel/PushRecordQuery",
          code:"/limitModel/PushRecordQuery",
          component: "limitModel/PushRecordQuery",
          code2:"PushRecordQuery",
          id: "60032",
          name:"限制库推送记录查询",
          order:0,
          parentId:"6000",
          parentMenu:"limitModel",
          title:"限制库推送记录查询",
          url:"/limitModel/PushRecordQuery"
        },
        {
          // code:"/limitModel/AllRestrictedLibraryData",
          code:"/limitModel/AllRestrictedLibraryData",
          component: "limitModel/AllRestrictedLibraryData",
          code2:"AllRestrictedLibraryData",
          id: "60032",
          name:"查询全国限制库数据",
          order:0,
          parentId:"6000",
          parentMenu:"limitModel",
          title:"查询全国限制库数据",
          url:"/limitModel/AllRestrictedLibraryData"
        },


      ]
    },


    //电子证照管理
    {
      code:"ecertModel",
      component: "ecertModel",
      code2:"ecertModel",
      id: "6500",
      name:"电子证照管理",
      Icon: {
        components: "svg-avatar",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      order:0,
      parentId:null,
      title:"电子证照管理",
      path:"/ecertModel",
      child: [
                {
                  code:"/ecertModel/ecertOrgStamp",
                  component:"ecertModel/ecertOrgStamp",
                  code2: "ecertOrgStamp",
                  id: "65001",
                  name: "机构电子印章管理",
                  order: 0,
                  parentId: "6500",
                  parentMenu: "ecertModel",
                  title: "机构电子印章管理",
                  url:"/ecertModel/ecertOrgStamp"
                },
                {
                  code: "/ecertModel/ecertCert",
                  component: "ecertModel/ecertCert",
                  code2: "ecertCert",
                  id: "65001",
                  name: "电子证照信息管理",
                  order: 0,
                  parentId: "6500",
                  parentMenu: "ecertModel",
                  title: "电子证照信息管理",
                  url: "/ecertModel/ecertCert"
                },
                {
                  code: "/ecertModel/ecertChange",
                  component: "ecertModel/ecertChange",
                  code2: "ecertChange",
                  id: "65001",
                  name: "电子证照变更信息管理",
                  order: 0,
                  parentId: "6500",
                  parentMenu: "ecertModel",
                  title: "电子证照变更信息管理",
                  url: "/ecertModel/ecertChange"
                },
                {
                  code: "/ecertModel/ecertTask",
                  component: "ecertModel/ecertTask",
                  code2: "ecertTask",
                  id: "65011",
                  name: "电子证照任务执行管理",
                  order: 0,
                  parentId: "6500",
                  parentMenu: "ecertModel",
                  title: "电子证照任务执行管理",
                  url: "/ecertModel/ecertChange"
                }
      ]
    },
    //申请人信息管理
    {
      code:"applicantModel",
      component: "applicantModel",
      code2:"applicantModel",
      id: "7000",
      name:"申请人信息管理",
      Icon: {
        components: "svg-avatar",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      order:0,
      parentId:null,
      title:"申请人信息管理",
      path:"/applicantModel",
      child: [
        {
          code: "/applicantModel/RealNameVerification",
          component: "/applicantModel/RealNameVerification",
          code2: "basicRealNameVerification",
          id: "18010",
          name: "实名核验审核",
          order: 0,
          parentId: "18000",
          parentMenu: "platformDocking",
          title: "实名核验审核",
          url: "/applicantModel/RealNameVerification"
        },

        {
          code:"/applicantModel/SsouserSubModel",
          component: "applicantModel/SsouserSubModel",
          code2:"querySsouser",
          id: "70031",
          name:"申请人基本信息管理",
          order:0,
          parentId:"7000",
          parentMenu:"applicantModel",
          title:"申请人基本信息管理",
          url:"/applicantModel/SsouserSubModel"
        },

        {
          code:"/applicantModel/ScoreSubModel",
          component: "applicantModel/ScoreSubModel",
          code2:"ScoreSubModel",
          id: "70035",
          name:"国考信息管理",
          order:0,
          parentId:"7000",
          parentMenu:"applicantModel",
          title:"国考信息管理",
          url:"/applicantModel/ScoreSubModel"
        },
        {
          code:"/applicantModel/NormalPreServiceTeacherSubModel",
          component: "applicantModel/NormalPreServiceTeacherSubModel",
          code2:"NormalPreServiceTeacherSubModel",
          id: "70035",
          name:"师范生免试认定信息管理",
          order:0,
          parentId:"7000",
          parentMenu:"applicantModel",
          title:"师范生免试认定信息管理",
          url:"/applicantModel/NormalPreServiceTeacherSubModel"
        },

        {
          code:"/applicantModel/SsouserCollegeCertSubModel",
          component: "applicantModel/SsouserCollegeCertSubModel",
          code2:"SsouserCollegeCertSubModel",
          id: "70031",
          name:"学历信息管理",
          order:0,
          parentId:"7000",
          parentMenu:"applicantModel",
          title:"学历信息管理",
          url:"/applicantModel/SsouserCollegeCertSubModel"
        },
        {
          code:"/applicantModel/SsouserStudentSubModel",
          component: "applicantModel/SsouserStudentSubModel",
          code2:"SsouserStudentSubModel",
          id: "70031",
          name:"学籍信息管理",
          order:0,
          parentId:"7000",
          parentMenu:"applicantModel",
          title:"学籍信息管理",
          url:"/applicantModel/SsouserStudentSubModel"
        },


        {
          code:"/applicantModel/SsouserDegreeCertSubModel",
          component: "applicantModel/SsouserDegreeCertSubModel",
          code2:"SsouserDegreeCertSubModel",
          id: "70031",
          name:"学位信息管理",
          order:0,
          parentId:"7000",
          parentMenu:"SsouserDegreeCertSubModel",
          title:"学位信息管理",
          url:"/applicantModel/SsouserDegreeCertSubModel"
        },
        {
          code:"/applicantModel/SsouserPthCertSubModel",
          component: "applicantModel/SsouserPthCertSubModel",
          code2:"SsouserPthCertSubModel",
          id: "70031",
          name:"普通话证书信息管理",
          order:0,
          parentId:"7000",
          parentMenu:"applicantModel",
          title:"普通话证书信息管理",
          url:"/applicantModel/SsouserPthCertSubModel"
        },
        {
          code:"/applicantModel/OtherCertificatesModel",
          component: "applicantModel/OtherCertificatesModel",
          code2:"OtherCertificatesModel",
          id: "70031",
          name:"其他证书管理",
          order:0,
          parentId:"7000",
          parentMenu:"OtherCertificatesModel",
          title:"其他证书信息管理",
          url:"/applicantModel/OtherCertificatesModel"
        },
        {
          code:"/applicantModel/ssouserAccessqueryModel",
          component: "applicantModel/ssouserAccessqueryModel",
          code2:"ssouserAccessqueryModel",
          id: "70040",
          name:"性侵准入查询信息管理",
          order:0,
          parentId:"7000",
          parentMenu:"applicantModel",
          title:"性侵准入查询信息管理",
          url:"/applicantModel/ssouserAccessqueryModel"
        },

      ]
    },
    //网站发布
    {
      code:"/website",
      code2:"website",
      component: "website",
      Icon: {
        components: "svg-browser",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      id: "10113",
      name:"网站发布",
      order:0,
      parentId:null,
      title:"网站管理",
      path:"/website"
    },
    {
      code:"/tqcStat",
      code2:"tqcStat",
      component: "tqcStat",
      Icon: {
        components: "svg-browser",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      id: "10115",
      name:"大屏监测",
      order:0,
      parentId:null,
      title:"大屏监测",
      path:"/tqcStat"
    },


    //系统监测管理
    {
      code: "monitor",
      component: "monitor",
      code2: "monitor",
      id: "8000",
      name: "统计监测信息",
      Icon: {
        components: "svg-monitor-one",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      parentId: null,
      title: "统计监测信息",
      path: "/monitor",
      child: [
        {
          code:"/monitor/MonAlertSubModel",
          component: "MonAlertSubModel",
          code2:"MonAlertSubModel",
          id: "80001",
          name:"告警台管理",
          order:1,
          parentId:"8000",
          parentMenu:"monitor",
          title:"告警台管理",
          path:"/monitor/MonAlertSubModel"
        },
        {
          code:"/monitor/MonReportDesign",
          component: "MonReportDesign",
          code2:"MonReportDesign",
          id: "80002",
          name:"统计报表设计",
          order:1,
          parentId:"8000",
          parentMenu:"monitor",
          title:"统计报表设计",
          path:"/monitor/MonReportDesign"
        },
        {
          code:"/monitor/systemMonitor?type=1",
          component: "/monitor/systemMonitor",
          code2:"systemMonitor",
          id: "80007",
          name:"系统监测报表",
          order:0,
          parentId:"8000",
          parentMenu:"monitor",
          title:"系统监测报表",
          path:"/monitor/systemMonitor",

        },
        {
          code: "/monitor/regMonitor?type=2",
          component: "regMonitor",
          code2: "regMonitor",
          id: "80009",
          name: "认定业务报表",
          order: 0,
          parentId: "8000",
          parentMenu: "monitor",
          title: "认定业务监测",
          path: "/monitor/regMonitor",

        },
        {
          code: "/monitor/enrollMonitor?type=3",
          component: "enrollMonitor",
          code2: "enrollMonitor",
          id: "80010",
          name: "定期注册业务监测",
          order: 0,
          parentId: "8000",
          parentMenu: "monitor",
          title: "定期注册业务报表",
          path: "/monitor/enrollMonitor",

        },
        {
          code: "/monitor/historyMonitor?type=4",
          component: "historyMonitor",
          code2: "historyMonitor",
          id: "80010",
          name: "历史数据报表",
          order: 0,
          parentId: "8000",
          parentMenu: "monitor",
          title: "历史数据报表",
          path: "/monitor/historyMonitor",

        }
      ]
    },

    {
      code:"/eduDocModel",
      code2:"eduDocModel",
      component: "eduDocModel",
      Icon: {
        components: "svg-browser",
        theme: "outline",
        size: 20,
        fill: ["rgba(255, 255, 255, 0.65)"],
        strokeWidth: 3
      },
      id: "90113",
      name:"资料下载",
      order:0,
      parentId:null,
      title:"资料下载",
      path:"/eduDocModel"
    },

  ],
};

export default {
  ...state
};



// WEBPACK FOOTER //
// ./src/store/state.js